<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('stockClose.cycleYear')
            }}</label>
            <ts-date-picker-input
              :class="{ 'is-invalid': errors.has('cycle_year') }"
              format="YYYY"
              v-model="model.cycle_year"
              :disabled="isUpdate"
              :closeOnSelect="true"
            ></ts-date-picker-input>
            <div class="invalid-feedback" v-if="errors.has('cycle_year')">
              {{ errors.first('cycle_year') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('stockClose.cycleMonth')
            }}</label>
            <ts-date-picker-input
              :class="{ 'is-invalid': errors.has('cycle_month') }"
              format="MM"
              v-model="model.cycle_month"
              :disabled="isUpdate"
              :closeOnSelect="true"
            ></ts-date-picker-input>
            <div class="invalid-feedback" v-if="errors.has('cycle_month')">
              {{ errors.first('cycle_month') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('stockClose.branch')
            }}</label>
            <a-select
              style="width:100%"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              v-model.number="model.branch_id"
              :options="
                branches.map(el => ({
                  value: el.branch_id,
                  label: el.branch_name_en
                }))
              "
              @change="changeBranch"
              :disabled="isUpdate"
            ></a-select>
            <div class="validate" v-if="errors.has('branch_id')">
              {{ errors.first('branch_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('stockClose.warehouse')
            }}</label>
            <a-select
              v-model="model.location_id"
              :options="locations"
              class="ts-w-full"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :disabled="isUpdate"
            ></a-select>
            <div class="validate" v-if="errors.has('location_id')">
              {{ errors.first('location_id') }}
            </div>
          </div>
        </div>
        <b-alert
          ref="danger"
          variant="danger"
          dismissible
          :show="error_message.length > 0"
        >
          <ul class="ts-list-disc">
            <span class="text-primary"
              >There are some
              <span class="ts-font-bold ts-lowercase"
                >{{ type_message }} numbers</span
              >
              as below:</span
            >
            <li v-for="(message, index) in error_message" :key="index">
              {{ message }}
            </li>
            <span class="text-primary">not yet confirm received.</span>
          </ul>
        </b-alert>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right ts-space-x-3">
            <ts-button @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              outline
              color="primary"
              @click.prevent="saveAddNew"
              :waiting="waiting_new"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
              >{{ $t('stockClose.closeStock') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'stockCloseForm',
  data () {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      branches: [],
      locations: [],
      type_message: '',
      error_message: [],
      model: {
        cycle_year: moment().format('YYYY'),
        cycle_month: '',
        branch_id: null,
        location_id: null
      }
    }
  },
  created () {
    this.setEditData()
    this.fetchData()
  },
  computed: {
    ...mapState('stock/stockClose', ['edit_data']),
    isUpdate () {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    async fetchData () {
      this.loading = true
      await this.$store
        .dispatch('security/user/getBranchAssigned')
        .then(response => {
          this.branches = response.data
          if (!this.isUpdate) {
            this.model.branch_id = this.$store.state.authUser.user.default_branch.branch_id
          }
        })
      this.loading = false
      this.changeBranch()
    },
    changeBranch () {
      this.model.location_id = null
      this.loading = true
      this.$store
        .dispatch('report/resource/getLocation', {
          branch_id: [this.model.branch_id]
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en + ' | ' + el.branch.branch_name_en
          }))
          if (this.isUpdate) {
            this.model.location_id = this.edit_data.location_id
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async checkIsAllowClose (data) {
      this.error_message = []
      this.type_message = ''
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'stock/stockClose/checkIsAllowClose',
          data
        )
        if (!response[0].is_confirm_different_month && response[0].is_allow) {
          this.waiting = false
          this.waiting_new = false
          if (await this.$confirmModal.danger(response[0].messages + '?')) {
            return true
          }
        }

        if (!response[0].is_allow) {
          if (response[0].trans_type == 'Cycle closed') {
            this.$toasted.error(response[0].messages)
          } else {
            this.$refs.danger.localShow = true
            this.error_message = response[0].messages.split('|')
            this.type_message = response[0].trans_type
          }
          this.waiting = false
          this.waiting_new = false
          return false
        }

        if (response[0].is_confirm_different_month) {
          this.waiting = false
          this.waiting_new = false
          if (
            await this.$confirmModal.danger(
              '<span class="text-primary">There are some <b class="ts-lowercase">' +
                response[0].trans_type +
                ' numbers</b> as below: </span> <br /><small>' +
                response[0].messages +
                '</small><br /> <span class="text-primary">received in different month.</span> <br /> <br /> <span class="ts-font-bold text-warning">Are you sure to close stock?</span>'
            )
          ) {
            return true
          }
        }
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
        this.waiting = false
        this.waiting_new = false
      }
    },
    async onSave () {
      this.waiting = true
      if (await this.checkIsAllowClose(this.model)) {
        this.waiting = true
        this.$store
          .dispatch('stock/stockClose/store', this.model)
          .then(response => {
            this.$toasted.success(response.message)
            this.$emit('fetchData')
            this.$emit('cancel')
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.waiting = false
          })
      }
    },
    async saveAddNew () {
      this.waiting_new = true
      if (await this.checkIsAllowClose(this.model)) {
        this.waiting_new = true
        this.$store
          .dispatch('stock/stockClose/store', this.model)
          .then(response => {
            return this.$store.dispatch('stock/stockClose/fetch').then(res => {
              this.$toasted.success(response.message)
              this.clearInput()
              return Promise.resolve(res)
            })
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.waiting_new = false
          })
      }
    },
    async onUpdate () {
      this.waiting = true
      if (await this.checkIsAllowClose(this.model)) {
        this.waiting = true
        this.$store
          .dispatch('stock/stockClose/update', {
            id: this.edit_data.cycle_id,
            data: this.model
          })
          .then(response => {
            this.$toasted.success(response.message)
            this.$emit('fetchData')
            this.$emit('cancel')
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.waiting = false
          })
      }
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.cycle_year = this.edit_data.cycle_year
        this.model.cycle_month = this.edit_data.cycle_month
        this.model.branch_id = this.edit_data.branch_id
        this.model.location_id = this.edit_data.location_id
      }
    },
    clearInput () {
      this.model.branch_id = this.$store.state.authUser.user.default_branch.branch_id
      this.model.location_id = null
      this.model.cycle_month = ''
      this.model.cycle_year = moment().format('YYYY')
    }
  }
}
</script>
<style scoped>
.alert {
  margin-bottom: 4px 0 !important;
}
.ts-list-disc {
  margin-left: 10px;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 0rem;
}
</style>
